// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"6acf1eec","202":"72703719","355":"3cbc22f3","479":"a78b748f","580":"4bbe56a3","606":"2118f365","711":"a7f653b4"}[chunkId] + ".chunk.js";
};